<div class="chip_container">
  @for (chip of chips; track chip) {
    <div class="chip">{{chip}}</div>
  }
</div>